import React from 'react'
import { Controller } from 'react-hook-form'
import { TextArea } from 'app/components/atoms'
import { useTranslation } from 'app/i18n/client'
import { Control } from 'react-hook-form'
import { TextAreaProps } from 'app/components/atoms/TextArea/TextArea.props'

interface FormTextAreaProps extends TextAreaProps {
  control?: Control<any>
  name: string
  defaultValue?: string
  error?: any
  controllerProps?: any
}

const FormInput = ({
  controllerProps,
  control,
  name,
  defaultValue,
  error,
  ...rest
}: FormTextAreaProps) => {
  const { t } = useTranslation()

  return (
    <Controller
      control={control}
      render={({ field: { onChange, onBlur, value } }) => (
        <TextArea
          {...rest}
          value={value}
          onBlur={onBlur}
          onChange={(event) => {
            onChange(event.target.value)
          }}
          isError={!!error}
          errorMessage={t(error?.message)}
        />
      )}
      name={name}
      defaultValue={defaultValue}
      {...controllerProps}
    />
  )
}

export default FormInput
